import { jsxs as c, jsx as s } from "react/jsx-runtime";
import { cva as p } from "class-variance-authority";
import { cn as n } from "../../../lib/utils.js";
const f = p("absolute rounded-full border-2 border-[var(--bg-surface)]", {
  variants: {
    status: {
      online: "bg-green-500",
      offline: "bg-red-500",
      away: "bg-yellow-400",
      busy: "bg-[var(--text-secondary)]"
    },
    size: {
      sm: "w-2.5 h-2.5",
      md: "w-3.5 h-3.5",
      lg: "w-4 h-4"
    },
    position: {
      "top-right": "top-0 right-0",
      "bottom-right": "bottom-0 right-0",
      "top-left": "top-0 left-0",
      "bottom-left": "bottom-0 left-0"
    }
  },
  defaultVariants: {
    status: "online",
    size: "md",
    position: "top-right"
  }
});
function m({ status: t, size: e, position: r, pulse: a = !1, children: o, className: l, ...i }) {
  return c("div", { className: n("relative inline-block", l), ...i, children: [o, s("span", { className: n(f({ status: t, size: e, position: r }), a && "animate-pulse") })] });
}
m.displayName = "StatusIndicator";
function b({ src: t, alt: e = "Avatar", fallback: r, size: a = "md", status: o, position: l = "top-right", pulse: i = !1, className: d }) {
  const u = {
    sm: "w-8 h-8 text-xs",
    md: "w-10 h-10 text-sm",
    lg: "w-12 h-12 text-base",
    xl: "w-16 h-16 text-lg"
  };
  return s(m, { status: o, size: {
    sm: "sm",
    md: "sm",
    lg: "md",
    xl: "lg"
  }[a], position: l, pulse: i, className: d, children: s("div", { className: n("rounded-full bg-[var(--bg-muted)] border border-[var(--border-color)] flex items-center justify-center overflow-hidden", u[a]), children: t ? s("img", { src: t, alt: e, className: "w-full h-full object-cover" }) : s("span", { className: "text-[var(--text-primary)] font-semibold", children: r || e.charAt(0).toUpperCase() }) }) });
}
b.displayName = "StatusAvatar";
function h({ children: t, status: e, size: r = "md", position: a = "top-right", pulse: o = !1, className: l }) {
  return s(m, { status: e, size: r, position: a, pulse: o, className: l, children: t });
}
h.displayName = "StatusElement";
export {
  b as StatusAvatar,
  h as StatusElement,
  m as StatusIndicator
};
//# sourceMappingURL=StatusIndicator.js.map
